/**
 * Extrae TODOS los placeholders ${...} del XML ya reconstruido.
 */
export function extraerExpresiones(xml) {
  const resultados = []
  const regex = /\$\{([^}]+)\}/g

  let match
  while ((match = regex.exec(xml)) !== null) {
    resultados.push({
      tag: match[0], // Ej: ${nombreN1}
      contenido: match[1], // Ej: nombreN1
      index: match.index, // Posición en el XML
    })
  }
  return resultados
}
